// Centralised date/time formatting — always renders in Sri Lanka time (Asia/Colombo, UTC+5:30)
// regardless of the browser's local timezone. Backend continues to store timestamps in UTC.

const SL_TIMEZONE = 'Asia/Colombo';
const SL_LOCALE = 'en-LK';

export const TIMEZONE = SL_TIMEZONE;

/**
 * Format an ISO date-time (or Date) as a short Sri Lanka date + time.
 * Example: "22 Jul 2026, 6:15 PM"
 */
export const formatDateTime = (iso) => {
  if (!iso) return '';
  const d = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(SL_LOCALE, {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: SL_TIMEZONE,
  }).format(d);
};

/**
 * Format a date-only value in Sri Lanka time. Example: "22 Jul 2026"
 */
export const formatDate = (iso) => {
  if (!iso) return '';
  const d = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(SL_LOCALE, {
    dateStyle: 'medium',
    timeZone: SL_TIMEZONE,
  }).format(d);
};

/**
 * Format a time-only value in Sri Lanka time. Example: "6:15 PM"
 */
export const formatTime = (iso) => {
  if (!iso) return '';
  const d = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(SL_LOCALE, {
    timeStyle: 'short',
    timeZone: SL_TIMEZONE,
  }).format(d);
};

/**
 * Return the current date in Sri Lanka time as a YYYY-MM-DD string.
 * Useful for pre-filling date inputs so "today" reflects Colombo, not the browser.
 */
export const todayColomboISO = () => {
  const parts = new Intl.DateTimeFormat('en-CA', {  // en-CA gives YYYY-MM-DD ordering
    timeZone: SL_TIMEZONE,
    year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(new Date());
  const y = parts.find(p => p.type === 'year')?.value;
  const m = parts.find(p => p.type === 'month')?.value;
  const d = parts.find(p => p.type === 'day')?.value;
  return `${y}-${m}-${d}`;
};

/**
 * Return the current month/year in Sri Lanka time.
 */
export const currentColomboMonthYear = () => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: SL_TIMEZONE,
    year: 'numeric', month: 'numeric',
  }).formatToParts(new Date());
  return {
    month: parseInt(parts.find(p => p.type === 'month')?.value || '1', 10),
    year: parseInt(parts.find(p => p.type === 'year')?.value || String(new Date().getFullYear()), 10),
  };
};
